import { UIText2 } from '@cian/ui-kit';
import cx from 'clsx';
import * as React from 'react';

import { IconsMetro } from '../Icons/IconsMetro';
import { IconsTransport } from '../Icons/IconsTransport';
import { IOfferUnderground } from '../../types/recentlyViewedOffer';

import * as styles from './styles.css';

interface IUndergroundProps {
  underground: IOfferUnderground;
}

export const Underground: React.FC<IUndergroundProps> = ({
  underground: { time, transportType, color, iconType, name },
}) => {
  return (
    <div className={styles['container']}>
      <div style={{ color }} className={cx(styles['name'], (!time || !transportType) && styles['full_width'])}>
        <IconsMetro type={iconType || undefined} />
        <div className={styles['ellipsis']}>
          <UIText2>{name}</UIText2>
        </div>
      </div>
      {time && transportType && (
        <div className={styles['transport']}>
          <IconsTransport type={transportType} />
          <UIText2>{time}</UIText2>
        </div>
      )}
    </div>
  );
};
